export const CHECKOUT_DIRECT_ASSURANCE_QUESTIONNAIRE = 'fr/condo/direct-assurance-questionnaire';
export const CHECKOUT_KOZOO = 'kozoo';
export const CHECKOUT_KOZOO_NECESSARY_INFORMATION = 'necessary-information';
export const CHECKOUT_KOZOO_PACKAGE_SELECTION = 'package-selection';
export const CHECKOUT_KOZOO_PACKAGE_ADDONS = 'package-addons';
